<app-si-dialog header="Delete Intent Topic" [preventClose]="true" modalFooterClasses="si-dialog__footer--centered" (close)="onConfirmation(false)">
    <ng-template appDialogBody>
        <div class="px-16 py-8">
            <div class="flex items-start gap-5">
                <fa-icon class="text-danger shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
                <div>
                    <p class="m-0 pb-4">
                        The following Intent Topics you have chosen to remove are being used in one or more Intent Automations. Deleting them will remove them from your Intent Automation(s).
                    </p>
                    <p class="m-0 pt-2 font-bold">
                        {{ data?.topicNames }}
                    </p>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template appDialogFooter>
        <button matButton="outlined" type="button" (click)="onConfirmation(false)">
            Cancel
        </button>
        <button matButton="filled" class="mat-error" type="submit" (click)="onConfirmation(true)">
            Delete
        </button>
    </ng-template>
</app-si-dialog>
